import { render, staticRenderFns } from "./SpacingEdit.vue?vue&type=template&id=7afb00d2&scoped=true"
import script from "./SpacingEdit.vue?vue&type=script&lang=js"
export * from "./SpacingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afb00d2",
  null
  
)

export default component.exports